module.exports = __webpack_public_path__ + "static/media/gen-stores-mobile.32d548ea.svg";